import FundraisingEventDescription from './FundraisingEventDescription'

export default FundraisingEventDescription
